import { motion } from "framer-motion";
import { FEATURES, IMAGES } from "@/lib/data";
import { Reveal } from "@/lib/motion";

export const Features = () => {
  return (
    <section id="features" data-testid="features-section" className="bg-white py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: heading + image */}
          <div>
            <Reveal>
              <p className="text-gold-dark text-xs font-bold uppercase tracking-[0.25em] mb-4">For Drivers Who Want More</p>
              <h2 className="font-heading font-bold text-navy text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]">
                Everything you need to keep earning — included.
              </h2>
              <p className="mt-5 text-muted-foreground text-base md:text-lg leading-relaxed">
                Affordable weekly rentals built for rideshare and delivery drivers. No credit cards, no credit checks,
                and no hidden fees. Just get on the road and start making money.
              </p>
            </Reveal>
            <Reveal delay={0.12}>
              <div className="mt-8 rounded-2xl overflow-hidden border border-navy/10 shadow-xl">
                <img src={IMAGES.driver} alt="Happy driver" className="w-full h-64 md:h-80 object-cover" />
              </div>
            </Reveal>
          </div>

          {/* Right: bento features */}
          <div className="grid sm:grid-cols-2 gap-4">
            {FEATURES.map((f, i) => {
              const Icon = f.icon;
              return (
                <motion.div
                  key={f.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.4, delay: i * 0.06 }}
                  data-testid={`feature-card-${i}`}
                  className="group rounded-2xl border border-navy/10 bg-white p-6 hover:border-gold hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-xl bg-navy group-hover:bg-gold flex items-center justify-center transition-colors duration-300">
                    <Icon className="w-6 h-6 text-gold group-hover:text-navy transition-colors duration-300" />
                  </div>
                  <h3 className="mt-4 font-heading font-bold text-lg text-navy">
                    {f.title}
                  </h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                    {f.desc}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
